module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"RatingTable":null},"de":{},"sk":{}}')
  delete Component.options._Ctor
}
